var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarretleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.805084 5.13539L4.98044 0.960051C5.18182 0.758678 5.50829 0.758678 5.70965 0.960051L6.19663 1.44704C6.39766 1.64807 6.39805 1.97388 6.19749 2.17538L2.88845 5.5L6.19749 8.8246C6.39805 9.0261 6.39766 9.35191 6.19663 9.55294L5.70965 10.0399C5.50827 10.2413 5.1818 10.2413 4.98044 10.0399L0.805084 5.86461C0.603733 5.66324 0.603733 5.33676 0.805084 5.13539Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarretleft);
export default __webpack_public_path__ + "static/media/carretleft.56c0884d2cd4d9e467b27146e5aca68c.svg";
export { ForwardRef as ReactComponent };